//@flow
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import '../../../../css/react-draggable/css/styles.css';
import { translate } from "react-i18next";
import Spinner from '../../../../components/Spinner';
import CollapsibleItem from '../../../../components/CollapsibleItem';
import LayerLabel from './layerLabel/LayerLabel';
import UCheckbox from '../../../../components/checkbox/UCheckbox';

const LayerListWrapper = styled.div`
  overflow-y: auto;
  padding: 0 5px 0 5px;
  height: 100%;
`;

export class LayerList extends React.Component {
    lastGroupName: string = null;
    lastType: string = null;

    constructor(props) {
        super(props);
        this.state = {
            refresh: false,
        };
    }

    getSubgroupName(t, type) {
        let subgroupName: string = "";
        if (!type) return subgroupName;
        switch (type) {
            case 1:
                subgroupName = t("Point layers");
                break;
            case 2:
                subgroupName = t("Line layers");
                break;
            case 3:
                subgroupName = t("Polygon layers");
                break;
            case 4:
                subgroupName = t("Ortho Images");
                break;
            case 5:
                subgroupName = t("Elevation layers");
                break;
            default:
                subgroupName = t("Other layers");
        }

        return subgroupName;
    }

    createGroup(t, layers) {
        this.lastGroupName = null;
        const count = layers.length;
        let group = [];
        for (var i = 0; i < count; i++) {
            let groupName = layers[i].values_.groupName;
            if (groupName !== this.lastGroupName) {
                this.lastType = null;
                this.lastGroupName = groupName;
                const subgroups = this.createSubgroup(t, layers, i, groupName, count);
                group.push(<div key={i}>
                    <b>{t(groupName)}</b>
                    {subgroups[0]}
                </div>);
                i += subgroups[1] - 1;
            }
        }
        return group;
    }

    createSubgroup(t, layers, i, groupName, count) {
        let subgroups = [];
        let items = 0;
        for (var j = i; j < count; j++) {
            if (groupName !== layers[j].values_.groupName) break;
            const type = layers[j].values_.type;
            if (type !== this.lastType) this.lastType = type;
            if (type === this.lastType) {
                const elements = this.createLayerElement(t, layers, j, type, count);
                let title = this.getSubgroupName(t, type);
                if (!title) title = t("Main layers");
                subgroups.push(
                    <CollapsibleItem key={title} title={title}
                        startOpen={title === t("Main layers")}
                        actionButton={
                            <UCheckbox
                                onClick={(isVisible) => {
                                    this.changeSubgroupVisibility(elements, isVisible)
                                }}
                            />
                        }>
                        {elements.map(elem => {
                            const layerId = elem.get("id");
                            const layerKey = layerId !== undefined && layerId !== null ? layerId : elem.get("name");
                            return (
                                <div key={`layer_${layerKey}`}>
                                    <LayerLabel layer={elem} refresh={this.state.refresh} />
                                </div>
                            )
                        })}
                    </CollapsibleItem>
                );
                j += elements.length - 1;
                items += elements.length;
            }
        }
        return [subgroups, items];
    }

    createLayerElement(t, layers, j, type, count) {
        let elements = [];
        for (var k = j; k < count; k++) {
            const layer = layers[k];
            if (type !== layer.values_.type) break;
            elements.push(layer);
        }
        return elements;
    }

    //Change visible only on map!
    changeSubgroupVisibility(layers: Array<object>, checkboxVisible: boolean): void {
        layers.forEach(layer => {
            const visible = layer.values_.visible;
            if (checkboxVisible !== visible) {
                layer.setVisible(!visible);
            }
        });
        //Make children refresh (change checkboxes)
        this.setState({ refresh: !this.state.refresh });
    }

    render(): React.Node {
        const { t } = this.props;

        if (!this.props.layers) return <Spinner />;
        return (
            <LayerListWrapper>
                {
                    this.createGroup(t, this.props.layers.getArray().filter((layer) => {
                        return layer.values_.showInLegend;
                    }))
                }
            </LayerListWrapper>
        );
    }
};

const mapStateToProps = state => ({
    layers: state.mapData.get('olLayers'),
    // needed to fire render method, layers does not work
    layersConfig: state.mapData.get('layersConfig'),
    roles: state.auth.get('roles'),
});

export default translate("translations")(connect(mapStateToProps)(LayerList));    


// WEBPACK FOOTER //
// ./src/containers/content/map/popups/LayerList.jsx